




import Vue from 'vue';

export default Vue.extend({
	data() {
		return {
			showIframe: true,
		};
	},
	computed: {
		wmsSecurityguardUrl() {
			return `${this.dmsSys.DMSC_url}/wms/WmsSecurity`;
		},
	},
});
